import { SelectMenuItem } from '../components/Debriefing/Learningprocessoutputs/BasicSelect'

export default <T = string>(data: Array<T>): Array<SelectMenuItem> => {
	return data.map(d => ({
		value: d as any,
		createOptionContentText: d as any,
	}))
}
